import { Component, Input, input, ViewChild } from '@angular/core';
import { ChangeSourceType } from '@ag-common-lib/lib/lists/change-logs/change-source-type.enum';
import { AgentKeys } from '@ag-common-lib/lib/models/domain/agent.model';
import { Messages } from '@ag-common-lib/public-api';
import { ModalWindowComponent } from 'ag-common-svc/lib/components/modal-window/modal-window.component';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';

@Component({
  selector: 'ag-shr-signed-policies',
  templateUrl: './signed-policies.component.html',
  styleUrl: './signed-policies.component.scss',
})
export class SignedPoliciesComponent {
  @ViewChild('signedPoliciesModalComponent') signedPoliciesModalComponent: ModalWindowComponent;

  @Input() agentDbId!: string;
  canEdit = input<boolean>(true);
  canDelete = input<boolean>(true);
  canCreate = input<boolean>(true);
  sourceType = input<ChangeSourceType | null>(null);

  protected readonly BaseModelKeys = BaseModelKeys;
  readonly AgentKeys = AgentKeys;
  readonly Messages = Messages;
}
